import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'itpx-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input('value') _value = false;
  propagateChange = (_: any) => {};
  onTouched: any = () => { };

  constructor() { }

  get value() : any {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
    this.onTouched();
  }

  writeValue(value) {
    if(value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any) {
      this.propagateChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
  onSelect(e) {
    this.value = e.target.checked;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/controls/checkbox/checkbox.component.ts